<script lang="ts" module>
	export { cmsPageLink, cmsPageLinkAsLi, rmaBtn };
</script>

<script lang="ts">
	import { page } from '$app/state';
	import { m } from '$lib/paraglide/messages';
</script>

{#snippet cmsPageLink(identifier: string)}
	{#if page.data.cmsPages?.[identifier]}
		<a href="/{page.data.cmsPages[identifier].slug}">{page.data.cmsPages[identifier].title}</a>
	{/if}
{/snippet}

{#snippet cmsPageLinkAsLi(identifier: string)}
	{#if page.data.cmsPages?.[identifier]}
		<li>
			{@render cmsPageLink(identifier)}
		</li>
	{/if}
{/snippet}

{#snippet rmaBtn(order: SalesOrder)}
	{#if order.state === 'complete'}
		<a
			class="btn"
			data-sveltekit-reload
			href="/rma/login?order_customer_lastname={order.billing_address
				.lastname}&order_date={new Date(order.created_at)
				.toISOString()
				.split('T')[0]}&order_ref={order.ref}">{m.return()}</a
		>
	{/if}
{/snippet}
